import { Component, Input, OnInit } from '@angular/core';
import { IContact, ILeadData } from "../../../../../models/leads/leads.model";
import { DateTimeHelper } from "../../../../../helper/date-time.helper";
import { PhoneNumberHelper } from "../../../../../helper/phone-number.helper";
import { LOCALE_KEY } from "../../../../../services/user-service/user-token.service";

@Component({
  selector: 'fi-duplicate-contact',
  templateUrl: './duplicate-contact.component.html',
  styleUrls: ['./duplicate-contact.component.scss'],
  standalone: false,
})
export class DuplicateContactComponent {
  @Input() contactToDisplay: IContact;
  @Input() leadData: ILeadData;
  @Input() existingContact: boolean;
  @Input() differenceKeys: string[];
  @Input() contactEmptyCount: number;
  @Input() addressEmptyCount: number;
  @Input() selected: number;
  @Input() count: number;
  @Input() contentLength: number;
  @Input() emails: any[];

  dateTimeHelper = DateTimeHelper;
  nextCount = 1;

  constructor() {
  }

  get contactPhone(): string {
    return PhoneNumberHelper
      .getPhoneNumber(this.contactToDisplay?.PhonePrefix, this.contactToDisplay?.Phone);
  }

  get contactMobile(): string {
    return PhoneNumberHelper
      .getPhoneNumber(this.contactToDisplay?.MobilePrefix, this.contactToDisplay?.Mobile);
  }

  getNameLiterals( name: string ): string {
    if ( name ) {
      const splittedName = name.trim().split(/\s+/gm);
      return splittedName.map(c => c[0]).join('').toUpperCase();
    }

    return '';
  }

  getLanguage(): string {
    return sessionStorage.getItem(LOCALE_KEY);
  }

  hasDifferences( key: string ): string {
    return this.differenceKeys.find(el => el === key);
  }

  hasSameNames( value: string ): any {
    return this.emails.find(el => el === value);
  }

  getHeight( count: number ): string {

    switch ( count ) {
      case 1:
        return 'height';
      case 2:
        return 'double-height';
      case 3:
        return 'third-height';
      case 4:
        return 'fourth-height';
      case 5:
        return 'fifth-height';
      case 6:
        return 'sixth-height';
      case 7:
        return 'seventh-height';
    }
    return ''
  }

  getContentClasses(): string {
    let htmlClasses = '';
    if ( this.existingContact ) {
      htmlClasses += 'existing-content ';

      if ( this.selected === this.count ) {
        htmlClasses += 'existing-selected ';
      }

      if ( this.contentLength > 1 ) {
        htmlClasses += 'existing-multiple ';
      }
    } else if ( !this.existingContact ) {
      if ( !(this.selected === this.count) && (this.selected + this.nextCount === this.count) ) {
        htmlClasses += 'imported-contact-inner ';
      }
      if ( (this.selected === this.count) ) {
        htmlClasses += 'imported-selected ';
      }
      if ( this.selected < this.count ) {
        htmlClasses += 'mobile-imported ';
      }
    }

    return htmlClasses;
  }

  getTitleClasses(): string {
    let htmlClasses = '';
    if ( this.selected === this.count ) {
      htmlClasses += 'selected-title ';
    }
    if ( this.existingContact && this.contentLength > 1 ) {
      htmlClasses += 'existing-title';
    }
    return htmlClasses;
  }

  get showEmptyField(): boolean {
    return !(this.selected === this.count) && !this.existingContact && !(this.selected + this.nextCount === this.count);
  }
}
